"use strict";
/**
 * trsWidth Module
 * create by lilei
 * on 2017-11-6
 * Description 计算编辑页右侧主体内容的宽度
 */
angular.module('trsWidthModule', []).directive('trsWidth', ['$window', '$parse', '$timeout', function($window, $parse, $timeout) {

    return {
        restrict: 'EA',
        link: function(scope, iElement, iAttrs) {
            function contentWidth() {
                var rect = $('.creation')[0].getBoundingClientRect();
                var width=rect.right-rect.left;
                $(".switch_content").width(Math.floor(width) - $('.body_right_sidebar').width()-2);//2px去掉边框的影响
                if(width<=90){//宽度小于等于90则设置sidebar为90 设置content padding-bottom为0
                    $('.creation').width(90);
                    $(".switch_content").css("paddingBottom","0");
                }
            }
            $timeout(function() {
                contentWidth();
            });
            $("body").resize(function(event) {
                contentWidth();
            });
        }
    };
}]);